import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(2),
    paddingBottom: 0,
    maxWidth: 600,
    margin: '0 auto',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  copyButton: {
    margin: '0 auto 8px',
  },
  divider: {
    width: '100%',
  },
  body: {
    display: 'flex',
    width: '100%',
    gap: theme.spacing(4),
    marginTop: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: 0,
    },
  },
  bodyTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  qrCodeContainer: {
    margin: '0 auto',
    '& img': {
      maxWidth: 200,
    },
  },
  orderedList: {
    listStyleType: 'none',
    '& li': {
      marginBottom: theme.spacing(2),
      '& span': {
        fontWeight: 'bold',
      },
    },
  },
  errorIcon: {
    fontSize: 64,
    color: theme.palette.warning.main,
    marginBottom: theme.spacing(2),
  },
  errorContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
    margin: '0 auto',
    textAlign: 'center',
    minHeight: '70vh',
  },
  footer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginTop: theme.spacing(2),
  },
  links: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: theme.spacing(6),
  },
}));
